/*
 * @Description: 重构导航栏 这是当前使用的版本
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Nav } from '@alifd/next';
import style from './index.module.scss';
import { appHistory } from '@ice/stark-app';
import { event, store } from '@ice/stark-data';
import Cookies from 'js-cookie';

const { Item, SubNav } = Nav;

// 这里使用顶层常量，在页面中用于匹配当url改变时，重新定导航高亮项 （避免产生魔术字符串） start

/** 首页 */
const HOME = '/cjyx';
/** 客户管理 */
const CROWDMANAGE = '/CustomerManagement';
/** 精准订单筛选营销 */
const ORDERSELECTION = '/orderSelection';
/** 官方人群营销 */
const CROWDMARKETING = '/crowdMarketing';
/** 云鹿人群营销 */
const PRIVATECROWDMARKETING = '/privateCrowdMarketing';
/** 订单关怀 */
const ORDERSCARE = '/order/care';
/** 账户管理 */
const SMSPAYMENT = '/accountKeeper';
/** 短信消耗记录 */
const SMSPAYMENTRECORD = '/sms/consumption';
/** 短信模板 */
const SMSTEMPLATE = '/smstemplate';
/** 画布 */
const CANVASMARKETING = '/canvas/activities';
/** 模型 */
const SMSAUTOMARKET = '/smsautomarket/marketing';
/** 商品管理 */
const GOODSMANAGELIST = '/goodsManage/list';
/** 商品组管理 */
const GOODSMANAGEGROUP = '/goodsManage/group';
// 这里使用顶层常量，在页面中用于匹配当url改变时，重新定导航高亮项 （避免产生魔术字符串） end

/** 左侧导航栏组件 */
const Menu = (): JSX.Element => {
  const [selectedKeys, setSelectedKeys] = useState('/'); // 当前已选路由
const [menuData, setMenuData] = useState([]);

  // 初始化菜单数据
  useEffect(() => {
    const shopId = Cookies.get('shopId');
    const baseMenuData = [
      { label: '首页概览', key: HOME },
      { label: '客户管理', key: CROWDMANAGE },
      { label: '精准营销',
        key: 'MARKET',
        children: [
          {label: '官方人群营销', key: CROWDMARKETING},
          {label: '云鹿人群营销', key: PRIVATECROWDMARKETING},
          { label: '订单筛选营销', key: ORDERSELECTION },
        ]
      },
      { label: '订单关怀', key: ORDERSCARE },
      { label: '账户管理',
        key: 'SMS',
        children: [
          { label: '账户管理', key: SMSPAYMENT },
          { label: '短信消耗记录', key: SMSPAYMENTRECORD },
        ]
      },
      { label: '短信模板', key: SMSTEMPLATE },
      { label: '画布', key: CANVASMARKETING },
      {
        label: '模型',
        key: 'MODEL',
        children: [
          { label: '自动化营销管理', key: SMSAUTOMARKET }
        ]
      },
      {
        label: '商品管理',
        key: 'GOODSMANAGE',
        children: [
          { label: '商品管理', key: GOODSMANAGELIST },
          { label: '商品组管理', key: GOODSMANAGEGROUP }
        ]
      }
    ];

    // 当shopId为129950484时，添加画布菜单
    // if (shopId === '129950484' || shopId === '2608067') {
    //   baseMenuData.push({ label: '画布', key: CANVASMARKETING });
    // }

    setMenuData(baseMenuData);
  }, []);

  // useEffect(() => {
  //   init();
  // }, []);

  // /** 初始化函数 */
  // const init = (): void => {
  //   getPageData();
  // };
  // /**  获取数据 */
  // const getPageData = (): void => {
  //   // 菜单数据
  //   const MenuData = [
  //     { label: '首页概览', key: HOME },
  //     { label: '客户管理', key: CROWDMANAGE },
  //     { label: '精准营销', key: ORDERSELECTION },
  //     { label: '订单关怀', key: ORDERSCARE },
  //     { label: '账户管理',
  //       key: 'SMS',
  //       children: [
  //         { label: '账户管理', key: SMSPAYMENT },
  //         { label: '短信消耗记录', key: SMSPAYMENTRECORD },
  //       ]
  //     },
  //     { label: '短信模板', key: SMSTEMPLATE },
  //   ];
  //   setMenuData(MenuData);
  // };

  // 计算当前打开的菜单
  const getOpenKeys = (): string => {
    let openKey = '';
    // 遍历menuData，找到当前路由对应的一级菜单，并返回其key
    menuData.forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          if (window.location.pathname.includes(child.key)) {
            openKey = item.key;
          }
        });
      } else if (window.location.pathname.includes(item.key)) {
        openKey = item.key;
      }
    })
    return openKey;
  };
  const [openKeys, setOpenKeys] = useState(getOpenKeys()); // 打开的菜单
  /**
   *  点击切换菜单 */
  const handleOnSelect = (
    selectedKeys: string[],
    item: { props: { title: string } },
    extra: Object,
  ): void => {
    setSelectedKeys(selectedKeys[0]);

    /** 重定向至 目标页面 */
    const redirect = `/web${ selectedKeys[0]}`;
    /** 重定向至 目标页面名称 */
    const redirectPageName = item.props.title;

    appHistory.push(redirect);

    const Breadcrumb = {
      name: redirectPageName !== '首页概览' ? redirectPageName : '', // 一级页面名称
      url: redirect, // 一级页面url
    };

    // 设置Header面包屑导航
    event.emit('Breadcrumb', Breadcrumb);

    // 重置页面tabs高亮
    store.set('currentTab', '');
  };

  const handleOnOpen = (keys: any[]) => {
    setOpenKeys(keys);
  };

  // 监听导航变更事件，重设导航高亮
  const reSetNavCurrentKey = (url: string): string => {
    // 当前为首页 --- 特殊判断
    if (window.location.pathname === '/') {
      appHistory.push('/web/');

      return HOME;
    }

    let currentNav = '/'; // 当前路由高亮

    // 这里需要等待所有一级/二级页面url都获取后才能更好的适配
    let currentUrl = url.split('web')[1].split('?')[0];

    /** 获取最后一个字符，判断是否为“/”  true-去除“/”  false-不做操作 */
    const lastCharacter = currentUrl.charAt(currentUrl.length - 1);

    currentUrl =
      lastCharacter === '/'
        ? currentUrl.substr(0, currentUrl.length - 1)
        : currentUrl;

    /** 在这里增加导航高亮匹配项 */
    const allRouters = {
      '': HOME,
      '/': HOME,
      '/CustomerManagement': CROWDMANAGE,
      '/Crowd/upload': CROWDMANAGE,
      '/user/BlackList': CROWDMANAGE,
      '/crowd/upload': CROWDMANAGE,
      '/crowd/phoneUpload/create': CROWDMANAGE,
      '/orderSelection': ORDERSELECTION,
      '/orderSelection/createShortMesssage': ORDERSELECTION,
      '/crowdMarketing': CROWDMARKETING,
      '/crowdMarketing/create': CROWDMARKETING,
      '/privateCrowdMarketing': PRIVATECROWDMARKETING,
      '/privateCrowdMarketing/create': PRIVATECROWDMARKETING,
      '/order/care': ORDERSCARE,
      '/order/mission': ORDERSCARE,
      '/accountKeeper': SMSPAYMENT,
      '/sms/consumption': SMSPAYMENTRECORD,
      '/smstemplate': SMSTEMPLATE,
      '/canvas/activities': CANVASMARKETING,
      '/smsautomarket/marketing': SMSAUTOMARKET,
      '/smsautomarket/marketing/create': SMSAUTOMARKET,
      '/smsautomarket/marketing/cycleCreate': SMSAUTOMARKET,
      '/goodsManage/list': GOODSMANAGELIST,
      '/goodsManage/group': GOODSMANAGEGROUP,
    };
    // 把/order/care/:type/:taskType/:taskId当作/order/care进行匹配，到此路由时，会自动匹配到/order/care
    if (currentUrl.indexOf('/order/care') !== -1) {
      currentUrl = '/order/care';
    }
    currentNav = allRouters[currentUrl];
    // 如果这里allRouters[currentUrl] 为underfined,则表明路由没有匹配成功
    if (!allRouters[currentUrl]) {
      // 带参数的二级页面在这里匹配其对应的一级页面路由

      if (currentUrl.indexOf('/crowd/tag') !== -1) {
        currentNav = CROWDMANAGE;
        return currentNav;
      }

      if (currentUrl.indexOf('/crowdMarketing/marketingEffect') !== -1) {
        currentNav = CROWDMARKETING;
        return currentNav;
      }
      if (currentUrl.indexOf('/privateCrowdMarketing/marketingEffect') !== -1) {
        currentNav = PRIVATECROWDMARKETING;
        return currentNav;
      }
      if (currentUrl.indexOf('/orderSelection/marketingEffect') !== -1) {
        currentNav = ORDERSELECTION;
        return currentNav;
      }
      if (currentUrl.indexOf('/canvas/activities') !== -1) {
        currentNav = CANVASMARKETING;
        return currentNav;
      }
    }

    // 如果依旧没有找到高亮设置项，就默认高亮首页
    return currentNav || HOME;
  };

  useEffect(() => {
    setSelectedKeys(reSetNavCurrentKey(window.location.href));
  }, [window.location.href]);

  /** 处理：当用户导航至子级页面时 ，点击导航栏的父级导航，页面不重导向问题 */
  const redirectFatherPage = (selectedKey: string, clickKey: string): void => {
    // 当用户点击当前路由
    if (selectedKey === clickKey) {
      const url = window.location.href;
      const currentUrl = url.split('web')[1].split('?')[0];

      // 当前路由与用户点击的父路由不同时，强制页面重导向
      if (currentUrl !== clickKey) {
        appHistory.push(`/web${ clickKey}`);
      }
    }
  };

  const createNav = (menus) => {
    return menus.map((menu) => {
      if (menu.children) {
        return (
          <SubNav key={menu.key} label={menu.label}>
            {createNav(menu.children)}
          </SubNav>
        );
      } else {
        return (
          <Item key={menu.key} onClick={() => redirectFatherPage(selectedKeys, menu.key)}>
            {menu.label}
          </Item>
        );
      }
    });
  };

  return (
    <div className={`${style.douStoreNav}`}>
      <Nav
        type="primary"
        onSelect={handleOnSelect}
        selectedKeys={selectedKeys}
        onOpen={handleOnOpen}
        openKeys={openKeys}
        openMode="single"
        attr-intro="导航栏布局"
        embeddable
        hasArrow={false}
      >

        {createNav(menuData)}
      </Nav>
    </div>
  );
};

export default Menu;
